import { getAmplitudeInstance } from '../amplitudeHelpers';
import CustomRouteErrorMessage from '../enums/CustomRouteErrorMessage';
import RouteAssistantSplit from '../enums/RouteAssistantSplit';

type logCustomRouteUpdateFailedParams = {
  error_message: CustomRouteErrorMessage;
  split_type?: RouteAssistantSplit;
};

/**
 * User attemped to update the custom route and it did not succeed, including route assistant split failures.
 * @param params - Attributes to log with the amplitude event
 * @param params.error_message - Error message related to custom route update failute
 * @param params.split_type - The type of route assistant split that failed. Omit for non-split custom route update failures.
 */
const logCustomRouteUpdateFailed = ({ error_message, split_type }: logCustomRouteUpdateFailedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('custom route update failed', { 'error message': error_message, 'split type': split_type }, callback);
};

export default logCustomRouteUpdateFailed;
